import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import {usePoll} from '../../../../util/hooks/use-poll';

import {useGetAudienceForCount} from '../../graphql/hooks';

type Props = {
    id: string;
};

export function ProcessingSpinner(props: Props) {
    const [shouldPoll, setShouldPoll] = React.useState(true);

    const {audience, error, startPolling, stopPolling} = useGetAudienceForCount(props.id);

    React.useEffect(() => {
        if (error) {
            setShouldPoll(false);
        }
    }, [error, shouldPoll, audience, stopPolling]);

    usePoll({
        shouldPoll,
        startPolling: () => startPolling(2000),
        stopPolling,
    });

    return (
        <div title='Your audience is being built...'>
            <LoadingIcon size={12} fill={colors.blueDk} />
        </div>
    );
}
